module.exports = __webpack_public_path__ + "logo-anfr.3bdea994e933db0d870d9136efc2e889.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/footer/logo-anfr.png
// module id = 274
// module chunks = 0